// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import BaiduMap from 'vue-baidu-map'
import myheader from '@/components/header/header'
import myheadert from '@/components/header/header_0'
import axios from 'axios'
import qs from 'qs'
import global from '@/port/getPort'
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)
// Vue.use(axios)
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.prototype.global = global
// Vue.use(Vuex)
Vue.config.productionTip = false
Vue.component('myheader', myheader)
Vue.component('myheadert', myheadert)
Vue.use(BaiduMap, {
  ak: '5zaD3MlB52V1cArZaS2QgTXRChYQHEeu'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js